module.exports = __webpack_public_path__ + "img/icwithdraw.f81fa5b3.png";